module.exports = __webpack_public_path__ + "2cd19b4106e082e8d0d2bff403a2d2ca.png";